import React from 'react';
import { useNavigate } from 'react-router-dom';



function Rosaa() {
  const navigate = useNavigate(); 
  const userEmail=sessionStorage.getItem('userEmail');  

  const handleNavigate = () => {
    navigate('/Setupa');
  };

  const handleNavigate1 = () => {
    navigate('/SafetyOutline');
  };

  const handleNavigate2 = () => {
    navigate('/Run');
  };
  

  
  if (!userEmail){
    navigate('/signin');
    return null;  
  }


  return (
    <div id="image-container">
<center>
      <h2 className="center-heading" style={{ color: 'pink' }}>ROSA-A Main Page</h2><br />
       <p>Signed in as:{userEmail}</p>

      <div className="app">
        <div className="button-container">
          
<input
  style={{ backgroundColor: 'pink', marginTop: '10px', padding: '10px 20px',
           borderRadius: '5px', border: 'none', cursor: 'pointer',
           display: 'block', marginBottom: '10px' }}
  type="submit1" value="Setup" onClick={handleNavigate}
/>

<input
  style={{ backgroundColor: 'pink', marginTop: '10px', padding: '10px 20px',
           borderRadius: '5px', border: 'none', cursor: 'pointer',
           display: 'block', marginBottom: '10px' }}
  type="submit2" value="Safety Outline" onClick={handleNavigate1}
/>

<input
  style={{ backgroundColor: 'pink', marginTop: '10px', padding: '10px 20px',
           borderRadius: '5px', border: 'none', cursor: 'pointer',
           display: 'block', marginBottom: '10px' }}
  type="submit3" value="Run" onClick={handleNavigate2}
/>
</div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
<br />
      <br />
<br />
      <br />

          <footer className="footer-section">
        <div className="container-4">
          <div className="nav-items"></div>
          <div className="text-6">&copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.</div>
        </div>
      </footer>
</center>
    </div>
  );
}

export default Rosaa;

